// removed by extract-text-webpack-plugin
module.exports = {"iconDefault":"_1n3Dwq1OS5r5rTYBAHaLU_"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/src/Icons/dist/Icon.scss
// module id = ./node_modules/wix-style-react/dist/src/Icons/dist/Icon.scss
// module chunks = 0